module.exports = __webpack_public_path__ + "static/media/DrapCode.6e0ad4f3.png";